var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-card-title',{staticClass:"body-1 font-weight-bold"},[_c('div',{staticClass:"header-decoration"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }